export default "__VITE_ASSET__CQj62VER__"